import { safeNumber } from "../../helpers";
import { getTruthyValue } from "@draftkings/sportsbook-common-utils";
const bonusStatuses = ["Forfeit", "Returned"];
/**
 * Calculates the bet breakdown when betOverMaxBetAllowed is enabled
 * @param stake - Total stake amount
 * @param bonus - Bonus object with maxStake, betOverMaxBetAllowed, and optional regularPortionStake
 * @param formatAmount - Function to format amounts for display
 * @returns BetBreakdownResult or undefined if feature not applicable
 */
export function calculateBetBreakdown(stake, bonus, formatAmount) {
    // Feature flag check - if not enabled, no breakdown
    if (!bonus.betOverMaxBetAllowed || bonus.boostValue === 0 || bonusStatuses.includes(getTruthyValue(bonus.boostStatus, ""))) {
        return undefined;
    }
    // If betOverMaxBetAllowed is true, maxStake WILL exist per BE contract
    const maxStake = getTruthyValue(safeNumber(bonus.maxStake), 0);
    // Only return breakdown if stake actually exceeds maxStake
    if (stake <= maxStake) {
        return undefined;
    }
    const boostedStake = maxStake;
    // Use BE-provided value if it exists (even if 0), otherwise calculate
    const regularStake = getTruthyValue(safeNumber(bonus.regularPortionStake), stake - maxStake);
    const totalStake = boostedStake + regularStake;
    return {
        boostedStake,
        regularStake,
        isBetOverMaxAmount: bonus.betOverMaxBetAllowed,
        boostedStakeFormatted: formatAmount(boostedStake, ""),
        regularStakeFormatted: formatAmount(regularStake, ""),
        totalStakeFormatted: formatAmount(totalStake, ""),
    };
}
//# sourceMappingURL=calculateBetBreakdown.js.map